// OES产品类型
export const OES_PRODUCT_TYPE = 'OES';
// OES Plus
export const OES_PLUS_PRODUCT_TYPE = 'OES Plus';
// x86
export const X86_PRODUCT_TYPE = 'X86';
// 容器魔方
export const DC_PRODUCT_TYPE = 'DC';
// 纳思小星
export const NAS_PRODUCT_TYPE = 'nas';
export const ARM_PRODUCT_TYPE = 'arm';
// OEC产品名
export const OEC_PRODUCT_TYPE = 'OEC';
// OEC-turbo
export const OEC_TURBO_PRODUCT_TYPE = 'OEC-turbo';
// 手机宝
export const PNWX_PRODUCT_TYPE = 'PNWX';
// 算力平台设备类型
export const CPWX_PRODUCT_TYPE = 'CPWX';
// 赚钱宝电脑版
export const PC_PRODUCT_TYPE = 'PC';
// 玩客云
export const WKYC_PRODUCT_TYPE = 'WkyC';
// 赚钱宝3代Pro
export const ZQB3PRO_PRODUCT_TYPE = 'ZQB3pro';
// 赚钱宝3代Pro
export const SF_PRODUCT_TYPE = 'SF';
// 电脑宝
export const PC_PAL_PRODUCT_TYPE = 'PCWX';
// OEA设备
export const OEA_PRODUCT_TYPE = 'OEA';
// 迅雷PC设备
export const XLPC_PRODUCT_TYPE = 'XLPC';
// OEA lite设备
export const OEA_LITE_PRODUCT_TYPE = 'OEA lite';
// 网心云KoolCenter版
export const KOOL_PRODUCT_TYPE = 'KOOL';

// 容器设备类型，用于区分文件系统指标
export const CONTAINER_DEVICE_TYPES = [
  X86_PRODUCT_TYPE,
  NAS_PRODUCT_TYPE,
  DC_PRODUCT_TYPE,
  PC_PRODUCT_TYPE,
  CPWX_PRODUCT_TYPE,
];

export const NAT_TYPE = {
  '0': { tag: '未知', level: 0 },
  '1': { tag: '公网型', level: 7 },
  '2': { tag: '全锥型', level: 4 },
  '3': { tag: 'IP型', level: 3 },
  '4': { tag: '端口型', level: 2 },
  '5': { tag: '对称型', level: 1 },
  '5.1': { tag: '对称型', level: 1 },
  '6': { tag: 'DMZ型', level: 6 },
  '7': { tag: '映射型', level: 5 },
};

export const NAT_MAP = ['未知', '对称型', '端口型', 'IP型', '全锥型', '映射型', 'DMZ型', '公网型'];

export const DISK_TYPE = {
  '3': 'U盘',
  '2': 'ssd',
  '1': 'hdd',
  '0': '未知',
};

export const DEFAULT_TEXT = '--';

export const DEFAULT_GRADE_TEXT_MAP = {
  unknown: '未知',
  abnormal: '异常',
  optimize: '可优化',
  normal: '正常',
};

export const TIME_FORMAT = 'YYYY-MM';
